<template lang="pug">
	.preview-container
		.pdf-wrapper(v-if="previewAvailable")
			.loading-circles
				span
				span
				span
			//- We need some stupid hack with key to force pdf to rerender in certain edge cases
			//- Throws an error in console as well, but this is specific to vue-pdf
			pdf(
				class="pdf-preview"
				:key="key"
				:src="pdfURL"
				@error="onError"
			)
		//- fullscreen broken until we fix the stupid translate everything when the sidebar closes
		//- .pdf-fullscreen-container(v-else-if='showFullscreen')
		//- 	iframe.pdf-fullscreen(:src='ctePathway.pdfURL')
		//- 	button.button-glow.button-close(@click="showFullscreen = false") Close
		.preview-unavailable.spacey(v-else) No preview available
</template>

<script>
import pdf from 'vue-pdf';
import { debounce } from 'debounce';

export default {
  name       : 'cte-pathway-preview',
  components : {
    pdf
  },

  props : {
    ctePathway : Object
  },

  data() {
    return {
      // key required to force pdf component to unmount and draw to the canvas
      key : 0,
    };
  },

  computed : {
    imageAlt() {
      return this.ctePathway ? this.ctePathway.name : 'CTE Pathway';
    },

    previewAvailable() {
      return !!this.ctePathway.pdfURL;
    },
    pdfURL() {
      if ( this.ctePathway.pdfURL ) {
        return `${this.ctePathway.pdfURL}.pdf`;
      }
      return '';
    }
  },

  created() {
    /**
		 * Whenever the window resizes, the pdf needs to redraw or else it comes out
		 * blurry. Thus, force pdf to rerender on window resize using the random key
		 * method.
		 */
    this.handleWindowChange = debounce( this.handleWindowResize, 500 );
    window.addEventListener( 'resize', this.handleWindowChange, true );
  },

  beforeDestroy() {
    window.removeEventListener( 'resize', this.handleWindowResize );
  },

  mounted() {
    this.key = Math.round( Math.random() * 10000 );
  },

  methods : {
    handleWindowResize() {
      this.key = Math.round( Math.random() * 10000 );
    },

    onError( err ) {
      console.error( 'Error:', err );
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-container {

	.pdf-wrapper {
		position: relative;
		.loading-circles {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	.pdf-fullscreen-container {
		position: fixed;
		left: 0; top: 0;
		width: 100vw;
		height: 100vh;
		z-index: 10;

		.pdf-fullscreen {
			width: 100%;
			height: 100%;
		}
		.button-close {
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
		}
	}


	.preview-unavailable {
		text-align: center;
		font-style: italic;
		padding: 50px;
	}
}
</style>
